import AdminWelcomePageApp from "./AdminWelcomePageApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(AdminWelcomePageApp);
